export class ChiftIntegrationEntityLink {
  id: string;
  connection_id: string;

  constructor() {}

  public static createInstance(jsonData: ChiftIntegrationEntityLink): ChiftIntegrationEntityLink {
    const c = Object.assign(new ChiftIntegrationEntityLink(), jsonData);

    return c;
  }

  public static createInstances(jsonData: ChiftIntegrationEntityLink[]): ChiftIntegrationEntityLink[] {
    return jsonData.map(ChiftIntegrationEntityLink.createInstance);
  }

  isLink(connection: any): boolean {
    return this.id && this.connection_id === connection.connectionid;
  }
}
